import { OpeningHours, WorkDay, WorkingDayTime } from '@2meters/types'
import { DateTime, Interval } from 'luxon'

const DAY_KEYS: (keyof OpeningHours)[] = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU']

export const isWorkingTime = (
  openingHours: OpeningHours,
  timeZone: string = DateTime.now().zone.name
): boolean => {
  const now = DateTime.now().setZone(timeZone)
  const dayOfWeek = DAY_KEYS[now.weekday - 1]

  const dayInfo: WorkDay = openingHours[dayOfWeek]

  if (!dayInfo || !dayInfo.open || !dayInfo.workingTime) {
    return false
  }

  return dayInfo.workingTime.some(({ openingTime, closingTime }: WorkingDayTime) => {
    const opening = DateTime.fromISO(openingTime!, { zone: timeZone })
    const closing = DateTime.fromISO(closingTime!, { zone: timeZone })
    const interval = Interval.fromDateTimes(opening, closing)

    return interval.contains(now)
  })
}
